const namespaced = true
import api from '../../../../api/sap/invoice/traceability_sap.js';
import { downloadFile } from '../../../../src/helpers/util.js'

const state = {
    loadingReport: false,
    reportResult: [],
    loadingDocument:  false,
}
const mutations = {
    SET_REPORT_TRACEABILITY(state, value) {
        state.reportResult = value;
    },

    SET_LOADING_REPORT(state, value) {
        state.loadingReport = value;
    },

    SET_LOADINGD_DOCUMENT(state, value){
        state.loadingDocument = value;
    },

}

const actions = {

    //Funcion para obtener los datos de la tabla de reportes
    async getReportTraceability(context, data) {
        context.commit('SET_LOADING_REPORT', true);

        try {
            const report = await api.getReportTraceabilitySAP(data);
            context.commit('SET_REPORT_TRACEABILITY', report.data.report);
            report.data.report.length === 0 ? context.dispatch('notifications/add', { 'color': 'info', 'visibility': true, 'timeout': 5000, 'text': 'Sin registros' }, { root: true }) : '';
            return report.data.report;
        } catch (error) {
            context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: 'Internal Server Error', }, { root: true });
            context.commit('SET_REPORT_TRACEABILITY', []);
            //throw error;
        } finally {
            context.commit('SET_LOADING_REPORT', false);
        }
    },

    //Funcion para importar los datos a Excel 
    exportDocument(context, data) {
        
        
        return new Promise((resolve, reject) => {
            context.commit("SET_LOADINGD_DOCUMENT", true);
            api.exportDocumentSAP(data).then(function (res) {
                const today = new Date();
                const fileName = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}_reporte-de-trazabilidad.xlsx`;
                downloadFile(res.data, fileName);
                resolve(res.data);
                context.commit("SET_LOADINGD_DOCUMENT", false);
            })
                .catch((e) => {
                    const errorMsg = e.messages;
                    let finalMessage = "Ocurrió un error al exportar";
                    if (
                        errorMsg === "undefined\nundefined" ||
                        !errorMsg ||
                        errorMsg.trim() === "" ||
                        typeof errorMsg !== "string"
                    ) {
                        finalMessage = "Sin suficientes registros";
                    } else {
                        finalMessage = errorMsg;
                    }
                    context.dispatch(
                        "notifications/add",
                        {
                            color: "error",
                            visibility: true,
                            timeout: 5000,
                            text: finalMessage,
                        },
                        { root: true }
                    );
                    reject();
                    console.log(e);
                    context.commit("SET_LOADINGD_DOCUMENT", false);
                });
        });
    }
}
const getters = {
    getReport(state) {
        return state.reportResult;
    },
}

export default {
    namespaced,
    state,
    getters,
    mutations,
    actions
}
